import { AnimatePresence } from 'framer-motion';
import React from 'react';
import styles from './dropdown.module.scss';
import { motion } from 'framer-motion';
import useOnClickOutside from 'hooks/useOnClickOutside';
export const DropDownHeader = ({ children, onClick }) => {
  return (
    <button onClick={onClick} className={styles.dropdownheader}>
      {children}
    </button>
  );
};

export const DropDownBody = React.forwardRef(({ children, ...rest }, ref) => (
  <div ref={ref} className={styles.dropdownbody} {...rest} data-testid='dropdown body'>
    {children}
  </div>
));

export default function Dropdown({
  header,
  children,
  isOpen,
  setIsOpen,
  style,
}) {
  const clickOutRef = React.useRef();
  useOnClickOutside(clickOutRef, () => {
    if (setIsOpen) {
      setIsOpen(false);
    }
  });

  return (
    <div className={styles.dropdown} ref={clickOutRef}>
      <div
        onClick={() => setIsOpen && setIsOpen(!isOpen)}
        className={styles.trigger}
        data-testid="dropdownTrigger"
      >
        {header}
      </div>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2, easings: 'easeInOut' }}
            className={styles.dropdownbody}
            style={style}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
